import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addressLine1: {
    description: 'filterOptions.addressLine1',
    defaultMessage: 'Address Line 1',
    id: 'RWil5C',
  },
  addressLine2: {
    description: 'filterOptions.addressLine2',
    defaultMessage: 'Address Line 2',
    id: 'hTacwi',
  },
  addressValidationStatus: {
    description: 'filterOptions.addressValidationStatus',
    defaultMessage: 'Address Validation Status',
    id: 'iD8gaY',
  },
  allocationStatus: {
    description: 'filterOptions.allocationStatus',
    defaultMessage: 'Allocation Status',
    id: 'JbPY93',
  },
  amountPaid: {
    description: 'filterOptions.amountPaid',
    defaultMessage: 'Amount Paid',
    id: 'Ymk1UY',
  },
  assignedTo: {
    description: 'filterOptions.assignedTo',
    defaultMessage: 'Assigned To',
    id: 'RukUWk',
  },
  buyerId: {
    description: 'filterOptions.buyerId',
    defaultMessage: 'Buyer ID',
    id: 'eP7v1i',
  },
  buyerName: {
    description: 'filterOptions.buyerName',
    defaultMessage: 'Buyer Name',
    id: 'FKFLT4',
  },
  carrier: {
    description: 'filterOptions.carrier',
    defaultMessage: 'Carrier',
    id: 'ZkWy+1',
  },
  city: {
    description: 'filterOptions.city',
    defaultMessage: 'City',
    id: 'fkny/d',
  },
  company: {
    description: 'filterOptions.company',
    defaultMessage: 'Company',
    id: 'l1TMfT',
  },
  country: {
    description: 'filterOptions.country',
    defaultMessage: 'Country',
    id: 'u24cHM',
  },
  customField1: {
    description: 'filterOptions.customField1',
    defaultMessage: 'Custom Field 1',
    id: 'DHEUa8',
  },
  customField2: {
    description: 'filterOptions.customField2',
    defaultMessage: 'Custom Field 2',
    id: '9gGfeU',
  },
  customField3: {
    description: 'filterOptions.customField3',
    defaultMessage: 'Custom Field 3',
    id: 'oOLoHS',
  },
  customer: {
    description: 'filterOptions.customer',
    defaultMessage: 'Customer',
    id: 'aJNnHZ',
  },
  datePaid: {
    description: 'filterOptions.datePaid',
    defaultMessage: 'Date Paid',
    id: 'fwsxZV',
  },
  deliverByDate: {
    description: 'filterOptions.deliverByDate',
    defaultMessage: 'Deliver By Date',
    id: 'Udz/ED',
  },
  gift: {
    description: 'filterOptions.gift',
    defaultMessage: 'Gift',
    id: '0tgyl6',
  },
  internalNotes: {
    description: 'filterOptions.internalNotes',
    defaultMessage: 'Internal Notes',
    id: '/RPD8X',
  },
  itemName: {
    description: 'filterOptions.itemName',
    defaultMessage: 'Item Name',
    id: 'Yt4c5p',
  },
  itemSku: {
    description: 'filterOptions.itemSku',
    defaultMessage: 'Item SKU',
    id: '+VFVGZ',
  },
  lineItems: {
    description: 'filterOptions.lineItems',
    defaultMessage: 'Line Items',
    id: 'KT0Ecq',
  },
  marketplace: {
    description: 'filterOptions.marketplace',
    defaultMessage: 'Marketplace',
    id: 'YogB/j',
  },
  notesFromBuyer: {
    description: 'filterOptions.notesFromBuyer',
    defaultMessage: 'Notes From Buyer',
    id: '5E2jxp',
  },
  notesToBuyer: {
    description: 'filterOptions.notesToBuyer',
    defaultMessage: 'Notes To Buyer',
    id: 'lYH2X2',
  },
  orderDate: {
    description: 'filterOptions.orderDate',
    defaultMessage: 'Order Date',
    id: 'OxSQDW',
  },
  orderImportTime: {
    description: 'filterOptions.orderImportTime',
    defaultMessage: 'Order Import Time',
    id: 'RVw4Cg',
  },
  orderNumber: {
    description: 'filterOptions.orderNumber',
    defaultMessage: 'Order #',
    id: 'EbdBFK',
  },
  orderSubtotal: {
    description: 'filterOptions.orderSubtotal',
    defaultMessage: 'Order Subtotal',
    id: 'zErziv',
  },
  orderTotal: {
    description: 'filterOptions.orderTotal',
    defaultMessage: 'Order Total',
    id: 'CEhzc7',
  },
  package: {
    description: 'filterOptions.package',
    defaultMessage: 'Package',
    id: 'C7nyXT',
  },
  packingSlipPrinted: {
    description: 'filterOptions.packingSlipPrinted',
    defaultMessage: 'Packing Slip',
    id: 'Wqexh3',
  },
  warehouseStatus: {
    description: 'filterOptions.warehouseStatus',
    defaultMessage: 'Picking Status',
    id: 'fzQ9wf',
  },
  pickListPrinted: {
    description: 'filterOptions.pickListPrinted',
    defaultMessage: 'Pick List',
    id: 'TmDM06',
  },
  pickingException: {
    description: 'filterOptions.pickingException',
    defaultMessage: 'Picking Exception',
    id: 'DRhzma',
  },
  postalCode: {
    description: 'filterOptions.postalCode',
    defaultMessage: 'Postal Code',
    id: 'PUUHyj',
  },
  quantity: {
    description: 'filterOptions.totalQuantity',
    defaultMessage: 'Total Quantity',
    id: 'Dr+lZ9',
  },
  rate: {
    description: 'filterOptions.rate',
    defaultMessage: 'Rate',
    id: '9iXByC',
  },
  recipientName: {
    description: 'filterOptions.recipientName',
    defaultMessage: 'Recipient Name',
    id: 'gTFvm7',
  },
  requestedServiceMapped: {
    description: 'filterOptions.requestedServiceMapped',
    defaultMessage: 'Requested Service (Mapped)',
    id: 'zkbWM9',
  },
  requestedServiceMarketplace: {
    description: 'filterOptions.requestedServiceMarketplace',
    defaultMessage: 'Requested Service (Marketplace)',
    id: '+TtBDX',
  },
  residentialOrCommercial: {
    description: 'filterOptions.residentialOrCommercial',
    defaultMessage: 'Residential / Commercial',
    id: '0DMwrN',
  },
  shipByDate: {
    description: 'filterOptions.shipByDate',
    defaultMessage: 'Ship By Date',
    id: 'vguqbO',
  },
  shipFrom: {
    description: 'filterOptions.shipFrom',
    defaultMessage: 'Ship From',
    id: 'MY5gOS',
  },
  shippingPaid: {
    description: 'filterOptions.shippingPaid',
    defaultMessage: 'Shipping Paid',
    id: 'DlMYsD',
  },
  source: {
    description: 'filterOptions.source',
    defaultMessage: 'Source',
    id: 'hwo8Vm',
  },
  state: {
    description: 'filterOptions.state',
    defaultMessage: 'State',
    id: 'qSxY2U',
  },
  store: {
    description: 'filterOptions.store',
    defaultMessage: 'Store',
    id: 'gwPKWT',
  },
  tag: {
    description: 'filterOptions.tag',
    defaultMessage: 'Tag',
    id: '15Wjuc',
  },
  taxPaid: {
    description: 'filterOptions.taxPaid',
    defaultMessage: 'Tax Paid',
    id: '4L7ZeU',
  },
  tote: {
    description: 'filterOptions.tote',
    defaultMessage: 'Tote',
    id: 'tAozZk',
  },
  warehouse: {
    description: 'filterOptions.warehouse',
    defaultMessage: 'Warehouse Location',
    id: 'fyhjwu',
  },
  weight: {
    description: 'filterOptions.weight',
    defaultMessage: 'Weight',
    id: 'EfM+t+',
  },
  zone: {
    description: 'filterOptions.zone',
    defaultMessage: 'Zone',
    id: 'veDhff',
  },
  destination: {
    description: 'filterOptions.destination',
    defaultMessage: 'Destination',
    id: 'x/2Z+s',
  },
  shippingAccount: {
    description: 'filterOptions.shippingAccount',
    defaultMessage: 'Shipping Account',
    id: 'YPA7uR',
  },
  international: {
    description: 'Filter Editor Options - International ',
    defaultMessage: 'International',
    id: 'sMp6+Z',
  },
  recipientCompany: {
    description: 'Filter Editor Options - Recipient Company ',
    defaultMessage: 'Recipient Company',
    id: 'SsFndd',
  },
  residentialIndicator: {
    description: 'Filter Editor Options - Residential Indicator',
    defaultMessage: 'Residential Indicator',
    id: 'f7Q5dO',
  },
  billToProviderIndicator: {
    description: 'Filter Editor Options - Bill to Account',
    defaultMessage: 'Bill to My Account',
    id: 'oSwi8o',
  },
  billToPartyIndicator: {
    description: 'Filter Editor Options - Bill to Party',
    defaultMessage: 'Bill to Party',
    id: 'xIMBuS',
  },
  companyName: {
    description: 'filterOptions.brand',
    defaultMessage: 'Brand',
    id: 'NsXpxq',
  },
  rateShopper: {
    description: 'Test for dropdown option that handles the Rate Shopper filter',
    defaultMessage: 'Rate Shopper',
    id: 'SPxQB8',
  },
  paymentMethod: {
    description: 'orders.filterOptions.paymentMethod',
    defaultMessage: 'Payment Method',
    id: 'ctPtkU',
  },
  serialNumber: {
    description: 'filterOptions.serialNumber',
    defaultMessage: 'Serial #',
    id: 'Z9cURy',
  },
  service: {
    description: 'orders filter Options - shipping-service',
    defaultMessage: 'Service',
    id: 'WKC/oS',
  },
  shopifyshipfrom: {
    description: 'filterOptions.shopifyshipfrom',
    defaultMessage: 'Shopify Ship From',
    id: '6O2/1k',
  },
  shippingMode: {
    description: 'filterOptions.shippingMode',
    defaultMessage: 'Shipping Mode',
    id: 'IzOdgS',
  },
});
